var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box } from '@chakra-ui/layout';
import { Center, Flex, Icon, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { RiUserVoiceFill } from '@react-icons/all-files/ri/RiUserVoiceFill';
import { StoreContext } from '@/app/uistore/Rootstore';
let MainScreen = class MainScreen extends React.Component {
    componentDidUpdate() {
        setTimeout(() => this.checkAndPlayVideo(), 100);
    }
    checkAndPlayVideo() {
        const rstore = this.context;
        if (rstore.mediastore.centerstagevideoref !== null &&
            rstore.mediastore.centerstagevideoref.current !== null &&
            rstore.mediastore.centerstagevideoref.current.srcObject === null &&
            rstore.mediastore.centerstagepeer !== '') {
            const peer = rstore.mediastore.getPeerMediaObject(rstore.mediastore.centerstagepeer);
            if ((peer === null || peer === void 0 ? void 0 : peer.mediastream) !== undefined) {
                rstore.mediastore.centerstagevideoref.current.srcObject = peer === null || peer === void 0 ? void 0 : peer.mediastream;
                rstore.mediastore.centerstagevideoref.current.play();
            }
        }
    }
    render() {
        var _a;
        const rstore = this.context;
        if (rstore.mediastore.showerror) {
            React.createElement(Center, { w: '100%' },
                React.createElement(Text, { fontWeight: 'bold', color: 'lightgray' }, rstore.mediastore.error));
        }
        const centerstagepeer = rstore.mediastore.centerstagepeer;
        const peer = rstore.mediastore.getPeerMediaObject(rstore.mediastore.centerstagepeer);
        const hasvideo = rstore.mediastore.sharingpeerid.has(centerstagepeer) || !rstore.mediastore.peerhasnovideo;
        return React.createElement(Box, null,
            React.createElement("video", { id: 'mainscreen', className: (_a = peer === null || peer === void 0 ? void 0 : peer.mediacssclass) !== null && _a !== void 0 ? _a : '', style: { height: (centerstagepeer === '' || !hasvideo) ? '0vh' : '55vh', width: '100%', pointerEvents: 'none' }, ref: rstore.mediastore.centerstagevideoref }),
            (centerstagepeer === '' || !hasvideo) && React.createElement(Flex, { style: { alignItems: 'center', justifyContent: 'center', height: '56vh' } },
                React.createElement(Icon, { h: '120px', w: '120px', color: 'lightgrey', as: RiUserVoiceFill })),
            centerstagepeer !== '' && React.createElement(Flex, { style: { alignItems: 'center', justifyContent: 'center' } },
                React.createElement(Text, { color: 'lightgray', fontWeight: 'bold', fontSize: '23px' }, peer === null || peer === void 0 ? void 0 : peer.username)));
    }
};
MainScreen.contextType = StoreContext;
MainScreen = __decorate([
    observer
], MainScreen);
export { MainScreen };
